import { Box, Tab, TabList, Tabs } from '@chakra-ui/react';
import { features } from '@ui/components/Features';
import { useTransactionHistoryDrawerStore } from '@ui/components/TransactionHistoryDrawer/TransactionHistoryDrawer';
import UpdateBanners from '@ui/components/UpdateBanner/UpdateBanners';
import {
  PATH_DASHBOARD,
  PATH_DASHBOARD_ATOM,
  PATH_DASHBOARD_VNO,
} from '@ui/config/paths';
import { useRealPathname } from '@ui/hooks/router';
import { CoinModeProvider } from '@ui/hooks/useCoinMode';
import { isFeatureEnabled } from '@ui/hooks/useIsFeatureEnabled';
import { PRELAUNCH } from '@ui/utils/constants';
import { pushRouterWithoutRerender } from '@ui/utils/urlHistory';

import Staking from './Staking';
import { Vaults } from './Vaults';

const croMode = {
  mode: 'cro',
  text: 'CRO',
  routePath: PATH_DASHBOARD,
} as const;
const atomMode = {
  mode: 'atom',
  text: 'ATOM',
  routePath: PATH_DASHBOARD_ATOM,
} as const;
const vnoMode = {
  mode: 'vno',
  text: 'VNO',
  routePath: PATH_DASHBOARD_VNO,
} as const;
export const modes = isFeatureEnabled(features.Atom)
  ? ([croMode, atomMode, vnoMode] as const)
  : ([croMode, vnoMode] as const);

export const DashboardMobile = () => {
  const realPathname = useRealPathname();
  const toggleTransactionHistoryDrawer = useTransactionHistoryDrawerStore(
    (s) => s.toggle,
  );

  return (
    <Box flexGrow={1}>
      <Box w="full" px={4}>
        <UpdateBanners h="170px" />
      </Box>
      <Tabs
        role="heading"
        aria-label="dashboard"
        aria-level={1}
        index={modes.findIndex((v) => v.routePath === realPathname)}
        onChange={(index) => {
          const mode = modes[index];
          pushRouterWithoutRerender(mode.routePath);
        }}
        isLazy={true}
      >
        <TabList>
          {modes.map((v) => {
            return (
              <Tab key={v.mode} isDisabled={PRELAUNCH && v.mode === 'vno'}>
                {v.text}
              </Tab>
            );
          })}
        </TabList>
        {realPathname === PATH_DASHBOARD && (
          <CoinModeProvider value="cro">
            <Staking
              coinMode="cro"
              showTransactionHistory={toggleTransactionHistoryDrawer}
            />
          </CoinModeProvider>
        )}
        {realPathname === PATH_DASHBOARD_ATOM && (
          <CoinModeProvider value="atom">
            <Staking
              coinMode="atom"
              showTransactionHistory={toggleTransactionHistoryDrawer}
            />
          </CoinModeProvider>
        )}
        {realPathname === PATH_DASHBOARD_VNO && <Vaults />}
      </Tabs>
    </Box>
  );
};
